import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getFirestore } from "firebase/firestore";
import { getMessaging } from "firebase/messaging";
import { getRemoteConfig } from "firebase/remote-config";
import { getStorage } from "firebase/storage";

// const FB_ENV = import.meta.env.VITE_FIREBASE_ENV;

const firebaseConfig = {
  prod: {
  apiKey: "AIzaSyDRKG40ff8S3qfjVHit3KB0gvYC2WRPmPE",
  authDomain: "eliteacademyeg-a7552.firebaseapp.com",
  databaseURL: "https://eliteacademyeg-a7552-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "eliteacademyeg-a7552",
  storageBucket: "eliteacademyeg-a7552.appspot.com",
  messagingSenderId: "958297622504",
  appId: "1:958297622504:web:7bdd5201c7c93f6422465d",
  measurementId: "G-BNV4PJQZJ1"
},
  beta: {
  apiKey: "AIzaSyDXNnOJBi3V8ji6CBZpsIQRENLlGqn6cgk",
  authDomain: "eliteacademyeg-beta.firebaseapp.com",
  databaseURL: "https://eliteacademyeg-beta-default-rtdb.firebaseio.com",
  projectId: "eliteacademyeg-beta",
  storageBucket: "eliteacademyeg-beta.firebasestorage.app",
  messagingSenderId: "9122958751",
  appId: "1:9122958751:web:b54df192ad912394b941aa",
  measurementId: "G-RLG2C97NBN"
},
};

export const app = initializeApp(firebaseConfig.prod);

export const db = getFirestore(app);
export const realtimeDB = getDatabase(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const analytics = getAnalytics(app);
export const messaging = getMessaging(app);
export const remoteConfig = getRemoteConfig(app);

remoteConfig.settings.minimumFetchIntervalMillis = 600000;
